// JSON-LD helpers for SEO. Keep flat objects with optional fields; consumers
// pass these into useSEO({ jsonLd }).

const SITE = "https://flyg.info";

export type Crumb = { name: string; url: string };

export function breadcrumbsJsonLd(items: Crumb[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.name,
      item: c.url,
    })),
  };
}

export function faqJsonLd(items: { q: string; a: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };
}

export function airportJsonLd(a: {
  name?: string;
  iata?: string;
  icao?: string;
  city?: string;
  country?: string;
  lat?: number;
  lon?: number;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Airport",
    name: a.name || a.iata,
    iataCode: a.iata,
    icaoCode: a.icao,
    address:
      a.city || a.country
        ? {
            "@type": "PostalAddress",
            addressLocality: a.city,
            addressCountry: a.country,
          }
        : undefined,
    geo:
      a.lat != null && a.lon != null
        ? { "@type": "GeoCoordinates", latitude: a.lat, longitude: a.lon }
        : undefined,
    url: a.iata ? `${SITE}/airport/${a.iata}` : undefined,
  };
}

export function flightJsonLd(opts: {
  flightNumber: string;
  airlineName?: string;
  origIata?: string;
  origName?: string;
  destIata?: string;
  destName?: string;
  departureTime?: string;
  arrivalTime?: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Flight",
    flightNumber: opts.flightNumber,
    airline: opts.airlineName ? { "@type": "Airline", name: opts.airlineName } : undefined,
    departureAirport: opts.origIata
      ? { "@type": "Airport", iataCode: opts.origIata, name: opts.origName }
      : undefined,
    arrivalAirport: opts.destIata
      ? { "@type": "Airport", iataCode: opts.destIata, name: opts.destName }
      : undefined,
    departureTime: opts.departureTime,
    arrivalTime: opts.arrivalTime,
  };
}

export function gameJsonLd(opts: { name: string; url: string; description: string }) {
  return {
    "@context": "https://schema.org",
    "@type": "Game",
    name: opts.name,
    url: opts.url,
    description: opts.description,
    inLanguage: "sv-SE",
    applicationCategory: "Game",
  };
}

export const SITE_URL = SITE;